export const debugPortfolioHistory = (
  event: string,
  details: Record<string, unknown>,
) => {
  if (!import.meta.env.DEV) {
    return;
  }

  // biome-ignore lint/suspicious/noConsole: scoped diagnostics are intentional in development
  console.debug(`[ATD portfolio-history] ${event}`, details);
};
